export class FeesIncrease {
    // public ID: number = 0;
    public UpdateAdminFeesIncreaseDetails: Array<any> = [];
}